import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChainTypeDropdownComponent } from './chain-type-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [ChainTypeDropdownComponent],
  exports: [ChainTypeDropdownComponent]
})
export class ChainTypeDropdownModule { }
